//graphgl
const endpoint = 'https://pixusbase.myshopify.com/api/2022-10/graphql.json';
const gl_token='9a7aea86bc5c0b62b383e4b3d4ede82c';
var productsForFilter=[];
function FetchData(query,callback) {
  
  fetch(endpoint,   {
  'async': true,
  'crossDomain': true,
  'method': 'POST',
  'headers': {
    'X-Shopify-Storefront-Access-Token': gl_token,
    'Content-Type': 'application/graphql',
  },
    body:  query
  }).then(res => res.json())
  .then(data => {
    callback(data)
  });
  
}

function FetchDataWithVariables(queryData,variablesData,callback) {
  
  fetch(endpoint,   {
  'async': true,
  'crossDomain': true,
  'method': 'POST',
  'headers': {
    'X-Shopify-Storefront-Access-Token': gl_token,
    'Content-Type': 'application/json',
  },
    body: JSON.stringify ({query:queryData,variables:variablesData})
  }).then(res => res.json())
  .then(data => {
    callback(data)
  });
  
}


function _getMetaProducts(ids,callback) {
  FetchData(`query {
    nodes(ids: ${JSON.stringify(ids)}) {
    ...on Product {
      id
            metafields (identifiers: [ 
 {namespace: "accentuate", key: "overlay"} 
]){           
          value
          key
          namespace
    }
  }
}}`,function(_data) {      
      callback.apply(_data);
});
}
// prevent load spr.js
if (document.getElementsByClassName('template-product').length==0) {
const insertBeforeElementBackup = Element.prototype.insertBefore
Element.prototype.insertBefore= function(...args) {   
    if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("spr.js") ==-1))        
        return insertBeforeElementBackup.apply(this,args)
}
}

//prevent load font awesome  from 3rd party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild= function(...args) { 
  if (args[0].nodeName && args[0].nodeName=='SCRIPT' && args[0].src.indexOf('jquery.min.js')!=-1) {
    if (window.SPR!=undefined) {
      $.ajaxSetup({ cache: !0 }),
      SPR.loadjQueryExtentions($),
      $(document).ready(function () {
        SPR.$=jQuery;
    return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      })
    }
    return ;
  }
 if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css") ==-1))      
   return appendElementBackup.apply(this,args)
}

if ($('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').length>0)
$('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').remove()

var W_width = $(window).width(), W_height = $(window).height();
$(window).on('resize', function () {
  if($(window).width() != W_width || $(window).height() != W_height){
    W_width = $(window).width();
    W_height = $(window).height();
    _initResize();
  }
});
$(window).on('load', function () {
  _initResize();
});

// Filters
function _initResize() {
  initSwatches();
  $('.filter-refine').off('click');
  $('.filter-overlay, .filter__close, .filter__apply').off('click');
  $('.filter-sort__title').off('click');
  $(document).off('click.resize');
  $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
  $('.filters__container').removeClass('filters__container--sticky');
  $('html').removeClass('no-scroll');
  $('.filter-sort__list').css('display','');
  $('.filter-sort').off('click');
  // Filters Mobile/Tablet
if ($(window).width() < 1365) {
  // Filters - Open
  $('.filter-refine').on('click', function () {
    $('.filter').toggleClass('filter--active');
    $('.filters__container').removeClass('filters__container--sticky');
    $('.filter-overlay').addClass('filter-overlay--active');
    $('html').addClass('no-scroll');
    return false;
  });

  // Filter - Close
  $('.filter-overlay, .filter__close, .filter__apply').on('click', function () {
    $('.filter').removeClass('filter--active');
    $('.filter-overlay').removeClass('filter-overlay--active');
    $('html').removeClass('no-scroll');
    return false;
  });
}

// Sort Tablet/Desktop
if ($(window).width() > 599) {
  $('.filter-sort__title').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter-sort__list--active')) {
      $this.next().removeClass('filter-sort__list--active');
      $this.next().slideUp(150);
    } else {
      $this.parent().parent().find('.filter-sort .filter-sort__list').removeClass('filter-sort__list--active');
      $this.parent().parent().find('.filter-sort .filter-sort__list').slideUp(150);
      $this.next().toggleClass('filter-sort__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter-sort__title--active')) {
      $this.removeClass('filter-sort__title--active');
      $this.attr('aria-expanded','false');
    } else {
      $this.attr('aria-expanded','true');
      $this.parent().find('.filter-sort .filter__title').removeClass('filter-sort__title--active');
      $this.toggleClass('filter-sort__title--active');
    }

  });

  $(document).on('click.resize',function (e) {
    if (!$(e.target).is(".filter-sort *")) {
      $('.filter-sort__list').removeClass('filter-sort__list--active');
      $('.filter-sort__title').removeClass('filter-sort__title--active');
      $('.filter-sort__list').slideUp(150);
    }
  }); 
}

// Sort Mobile
if ($(window).width() < 600) {
  $('.filter-sort').on('click', function () {    
    $(this).children('.filter-sort__list').toggleClass('filter-sort__list--active');
    $('.filter-sort-overlay').toggleClass('filter-sort-overlay--active');
    $('.filters__container').removeClass('filters__container--sticky');
    $('html').toggleClass('no-scroll');
    return false;
  });
  $(document).on('click.resize',function (e) {
    if (!$(e.target).is(".filter-sort *") && !$(e.target).is(".filter__group *")) {
      $('.filter-sort__list').removeClass('filter-sort__list--active');
      $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
      $('html').removeClass('no-scroll');
      
    }
  }); 
}
previousScroll = 0;
headerOrgOffset = 0;
if ($(window).width() > 1365) {
  if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28;
} else {
  if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top;
}
  
};
// Filters All
$(document).ready(function() {

  loadswatches();
 _initFilter();

  $(document).off('click').on('click',function(e) {
    if (!$(e.target).is(".filter__group *")) {
      $('.filter__list').removeClass('filter__list--active');
      $('.filter__title').removeClass('filter__title--active');
      $('.filter__list').slideUp(150);
    }
  });
});


function _initFilter() {
   // Filter - Accordion
  $('.filter__title').off('click').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter__list--active')) {
      $this.next().removeClass('filter__list--active');
      $this.next().slideUp(150);
      
    } else {
      $this.parent().parent().find('.filter__group .filter__list').removeClass('filter__list--active');
      $this.parent().parent().find('.filter__group .filter__list').slideUp(150);
      $this.parent().parent().find('.filter__group .filter__title').removeClass('filter__title--active');
      $this.next().toggleClass('filter__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter__title--active')) {
      $this.removeClass('filter__title--active');
      $this.attr('aria-expanded','false');
    } else {
      $this.addClass('filter__title--active');
      $this.attr('aria-expanded','true');
    }

  });


}
// Canvas Cart
var dataOffcanvas;
$(document).ready(function() { 
  $( function(){


    $( document ).on( "beforecreate.offcanvas", function( e ){
      dataOffcanvas = $( e.target ).data('offcanvas-component');
    } );

    $( document ).on( "create.offcanvas", function( e ){
      var dataOffcanvas = $( e.target ).data('offcanvas-component');

    } );

    $( document ).on( "clicked.offcanvas-trigger clicked.offcanvas", function( e ){
      var dataBtnText = $( e.target ).text();
    } );

    $( document ).on( "open.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "resizing.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "close.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "destroy.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( '#bottom' ).on( "create.offcanvas", function( e ){
      var api = $(this).data('offcanvas-component');

      $('.js-destroy').on('click', function () {
        api.destroy();
        //$( '#top' ).data('offcanvas-component').destroy();
      });
    } );

    $( '#left' ).offcanvas( {
      modifiers: "left,overlay",
      triggerButton: '.js-offcanvas-trigger-left'
    } );

    $('.js-enhance').on('click', function () {
      $( document ).trigger( "enhance" );
    });

    $( document ).trigger( "enhance" );
    
  });
});

// Filter Switch
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

var layouts={
  desktop:[4,3],
  tablet:[3,2],
  mobile:[2,1]
}

function getWindowLayout() {
  var _windowWidth=jQuery(window).width();
  if ( _windowWidth< 767) {
    return layouts.mobile;
  }
  else if (_windowWidth < 1024) {
    return layouts.tablet;
  }
  else {
    return layouts.desktop;
  }
}

function switchLayout(isFirst,isNext) {
  var perRow=1;
  if (isFirst===true) {
    var _perCookie= getCookie("perrow");
    if (_perCookie!=undefined) perRow=parseInt(_perCookie);
  }
  var currentPerRow=$('.filter-switch__grid').get(0).className.match(/show(\d)/);
  if (currentPerRow!=null) {
    perRow=parseInt(currentPerRow[1]); 
  }
  var _currentLayout=getWindowLayout();

  if ($.inArray(perRow, _currentLayout)==-1) {
    perRow=_currentLayout[0];
  } 

  if (isNext===true) {
    perRow=_currentLayout[($.inArray(perRow, _currentLayout) + 1) % _currentLayout.length];
    setCookie("perrow",perRow);     
  }

  if(currentPerRow!=null) {     
    $('.filter-switch__grid').removeClass("filter-switch__grid--show"+currentPerRow[1]);   
    //$('.collection .col').removeClass("show"+currentPerRow[1]);   
  }
  $('.filter-switch__grid').addClass("filter-switch__grid--show"+perRow);  

  $('.collection .col').each(function() {
    var cn=this.className.match('xs-3');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-4');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-6');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-12');
    if (cn!=null) $(this).removeClass(cn[0]);
    var _classname="xs-3";
    switch(perRow) {
      case 1:      
      _classname="xs-12";
      break;
      case 2:
      _classname="xs-6";
      break;
      case 3:
      _classname="xs-4";
      break;
    }
    $(this).addClass(_classname);
  });
}

function layoutSwitch (isFirst) {
  if ($('.filter-switch').length>0) {
    switchLayout(isFirst);

    $('.filter-switch').off('click');
    $('.filter-switch').on('click',function() {
      switchLayout(false,true);
    });
  }
}
$(document).ready(function() {
  $(window).on('load resize', function() {
    layoutSwitch(true);
  });
});

// Header Sticky
var previousScroll = 0;
var headerOrgOffset =0;
if ($('.header').length>0)  headerOrgOffset =$('.header').offset().top;

$(window).scroll(function () {
  if ($('.header').length>0) {
    var currentScroll = $(this).scrollTop();
    if (currentScroll > headerOrgOffset) {
      if (currentScroll > previousScroll) {
        $('html:not(".no-scroll") .header').removeClass('header--sticky');
        //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').removeClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
      } else {
        $('html:not(".no-scroll") .header').addClass('header--sticky');
        //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').addClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
      }
    } else {
      $('html:not(".no-scroll") .header').removeClass('header--sticky');
      //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').removeClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
    }
    previousScroll = currentScroll;
  }
});

// Filter Sticky
if ($(".filters")[0]) {
  var previousScrollFilter = 0,
  headerOrgOffsetFilter = $('.filters').offset().top + (-62);

  $(window).scroll(function (e) {
    var currentScrollFilter = $(this).scrollTop();
    if (currentScrollFilter > headerOrgOffsetFilter) {
      if (currentScrollFilter > previousScrollFilter) {
        $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
      } else {
        $('html:not(".no-scroll") .filters__container').addClass('filters__container--sticky');
      }
    } else {
      $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
    }
    previousScrollFilter = currentScrollFilter;
  });
}

// Product Page - Sticky Button
$(document).on('scroll', function(){
  if ($(window).scrollTop() > 50){
    $('.product-add-mobile').addClass('product-add-mobile--sticky');
  } else {
    $('.product-add-mobile').removeClass('product-add-mobile--sticky');
  }
});

// Header Search Toggle
$(document).ready(function() {
  $('.header-search__toggle.header__icon').click(function () {
    $('.header-search__form').addClass('header-search__form--visible');
    $('.site-container').addClass('site-container--blackout');
    $('html').addClass('noscroll-search');
    $('.header-search__input').focus();
  });
  $('.header-search__back').click(function () {
    $('.header-search__form').removeClass('header-search__form--visible');
    $('.site-container').removeClass('site-container--blackout');
    $('html').removeClass('noscroll-search');
  });
  $(document).click(function (e) {
    if (!$(e.target).is(".header *")) {
      $('.site-container').removeClass('site-container--blackout');
      $('.header-search__form').removeClass('header-search__form--visible');
      $('html').removeClass('noscroll-search');
    }
  });
});       

// Collection Description Toggle
$(document).ready(function() { 
  $('.collection__toggle').off('click').on('click', function () {
    $('.collection__description-content').toggleClass('collection__description-content--visible');
    $('.collection__show-hide').toggle();
    return false;
  });
});

// Footer Accordions
$(document).ready(function() { 
  $('.footer-content__accordion-header').off('click').on('click', function () {
    $(this).toggleClass('footer-content__accordion-header--shown');
    $(this).next('.footer-content__accordion-content').slideToggle(200);
    return false;
  });
});

// Currency Converter
$(document).ready(function() { 
  $('.shopify-currency-form select').on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });
});

// Nav Mega Hover
$(".nav__mega .nav__sub-menu").css('display', 'flex').hide();
$(".nav__mega").on("mouseenter", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeIn();
  }
});
$(".nav__mega").on("mouseleave", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeOut();
  }
});
// Keyboard interaction - only open on Enter
$(".nav__mega .nav__link").on("keydown", function (e) {
  if (e.key === "Enter") {
    const $submenu = $(this).closest(".nav__dropdown").children(".nav__sub-menu");
    if ($submenu.is(":visible")) {
      $submenu.stop(true, true).fadeOut(); // Close if already open
      $('.nav-overlay').stop(true, true).fadeOut();
    } else {
      $submenu.stop(true, true).fadeIn(); // Open if closed
      $('.nav-overlay').stop(true, true).fadeIn();
    }
    e.preventDefault(); // Prevent default Enter behavior
  }
});

// Finance Popup - Klarna
$('.product-finance__link--klarna-30').on('click', function () {
  $('.product-finance-popup--klarna-30').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});
$('.product-finance__link--klarna').on('click', function () {
  $('.product-finance-popup--klarna').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Clearpay
$('.product-finance__link--clearpay').on('click', function () {
  $('.product-finance-popup--clearpay').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Laybuy
$('.product-finance__link--laybuy').on('click', function () {
  $('.product-finance-popup--laybuy').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Zip
$('.product-finance__link--zip').on('click', function () {
  $('.product-finance-popup--zip').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Close
$('.product-finance-popup__close').on('click', function () {
  $('.product-finance-popup').removeClass('product-finance-popup--active');
  $('html').removeClass('noscroll-finance-popup');
});

$(document).mouseup(function(e) {
  var container = $(".product-finance-popup *");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.product-finance-popup--active').removeClass('product-finance-popup--active');
    $('html').removeClass('noscroll-finance-popup');
  }
});

// Account Tabs
$('.account .tab').on('click', function () {
  var tab_id = $(this).attr('data-tab');
  $('.account__tab').removeClass('account__tab--active');
  $('.account__content').hide();
  $(this).addClass('account__tab--active');
  $("#"+tab_id).show();
});

// Mobile Nav
$(document).ready(function() { 

  // Clone
  $('.nav__sub-menu').each(function(){
    $(this).clone().addClass('nav__sub-menu--cloned').insertAfter(".header-nav").wrapInner("<div class='nav__sub-menu__wrap'></div>");
  });

  // Open & Close Nav (Mobile) - Click Function
  $('.header-mobile').off('click').on('click', function () {
    $(this).toggleClass('header-mobile--active');
    $('.header-nav').toggle();
    $('.header-nav').toggleClass('header-nav--active');
    $('.header').toggleClass('header--mobile-white');
    $('html').toggleClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').toggle();
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

  // Close Nav (Mobile) - Click Function
  $('.mobile-nav-overlay').off('click').on('click', function () {
    $('.header-mobile').removeClass('header-mobile--active');
    $('.header').removeClass('header--mobile-white');
    $('.header-nav').hide();
    $('.header-nav').removeClass('header-nav--active');
    $('html').removeClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').hide();
    $('.nav').removeClass('nav--hidden');
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
  });

  // Open Sub Menu - Click Function
  $('.nav__dropdown .nav__link').off('click').on('click', function (event) {
    if ($(window).width() < 1280) {
      event.preventDefault();
    }
    var id = $(this).attr('id');
    $('.nav__sub-menu').each(function(){
      var dataid = $(this).attr('data-id');
      console.log(dataid);
      if(id == dataid) {
        $(this).addClass('nav__sub-menu--active');
      }
    });
    $('.nav').addClass('nav--hidden');
  });

  // Back Button - Click Function
  $('.nav__sub-menu__back').off('click').on('click', function () {
    $('.nav__sub-menu').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

});

// Swatches
function initSwatches() {
  if (window.swatches!=undefined && document.location) {
    $('.swatches__col').off('mouseenter mouseleave');
    $('.swatches__col').off('click');

    if ($(window).width() > 599) {
    $('.swatches__col').hover(      
      function(){
        if ($(this).closest('[data-group-col]').length>0) {
        let _id=$(this).data('product-id');
        let _h=window.swatches.filter(function (e) { return (e.id  == _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else  {
          //swatch data not exist - need get firstly
          let el=this;
          var _handle;
          if (productsForFilter.length==0) {
            _handle=$(this).attr('href').replace('/products/','');
          }
          else {
            _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
          }
          if (_handle!=undefined) {
            getSwatchData(_handle,function(h) {
              showSwatchData(el,this);
            });
          }
        }
        }
      },function(){
        if ($(this).closest('[data-group-col]').length>0) {
        let _id=$(this).parent().find("[class*='--current']").closest('a').data('product-id');
        let _h=window.swatches.filter(function (e) { return (e.id  ==  _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else  {
          //swatch data not exist - need get firstly
          const el=this;
          var _handle=productsForFilter.filter(item => item.id ===_id)[0].handle;
          if (_handle!=undefined) {
            getSwatchData(_handle,function(h) {
              showSwatchData(el,this);
            });
          }
        }
      }
    }
    );
   }
   else {
     $('.swatches__col').on('click',function(e) {
       if ($(this).closest('[data-group-col]').length>0) {
        if ( $('div',this).hasClass('swatches__swatch--current')) return true;
        e.preventDefault();
        $(this).closest('.swatches').find('.swatches__swatch--current').removeClass('swatches__swatch--current');
        $('div',this).addClass('swatches__swatch--current');
        const _id=$(this).data('product-id');
        const _h=window.swatches.filter(function (e) { return (e.id  == _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else  {
          //swatch data not exist - need get firstly
          const el=this;
          var _handle;
          if (productsForFilter.length==0) {
            _handle=$(this).attr('href').replace('/products/','');
          }
          else {
            _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
          }
          if (_handle!=undefined) {
            getSwatchData(_handle,function(h) {
              showSwatchData(el,this);
            });
          }
        }
       return false;
       }
     });
 
   }

  }
}

function getSwatchData(_handle,callback) {     
  $.ajax({
      method    : 'GET',
      url       : document.location.origin+"/products/"+_handle+"/?view=swatch",        
      success: function (data) {
        var _d=data.replace(/\n/g,'').replace(/,}/g,'}');   
        window.swatches=window.swatches || [];
        const h=JSON.parse(_d);
        window.swatches.push(h);
    callback.apply(h);
   }
});
}
function showSwatchData(el,h) {
  var item=$(el).closest('.product-card');
  item.find('.product-card__image').attr("src", h.image);
  item.find('.product-card__image').attr("srcset", "");
  item.find('.product-card__title').text(h.title);
  item.find('.product-card__sku span').text(h.sku);
  item.find('.product-card__price-current').text(h.price);
  item.find('.product-card__price').removeClass('product-card__price--on-sale');
  item.find('.product-card__price').addClass(h.onsale);
  item.find('.product-card__price-compare').text(h.pricecompare);
  item.find('.product-card__price-saving').html(h.saving);
  item.find('.product-card__overlays').replaceWith(h.overlays); 
}

// Run Functions
function _checkafterLoadEvents() {
   window.afterLoadWithEvents.forEach(x=> {
      
      if (x.evt && !$(x.el).is(document)) {
        if ( x.evt==arguments[0].type && $(x.el).is(arguments[0].target)) {
          $(x.el).off(x.evt+'.'+x.f)
            if (typeof(x.f)=='function') {
              setTimeout(x.f,0);
            }
            else {
            window[x.f].apply();
            }
          window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
        }
      }
      else {
       if (typeof(x.f)=='function') {
          setTimeout(x.f,0);
       }
       else {
         window[x.f].apply();
       }
       window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
      }
       
   });
   if (window.afterLoadWithEvents.length==0) {
     $(window).off('scroll.afterLoad');
   }
}
function loadswatches(ismissed) {
  if (ismissed!==true) {
  //product detail group swatch    
  $('[data-group]').each(function() {
    let el=$(this);
    let tags=[];    
    const t='Product Group Code|'+$(el).data('group');
    tags.push(t);        
    renderSwatchAndOverlay(tags,function() {
        let _html='';
        _productsData.filter(p=>p.GroupCode==$(el).data('group')).forEach(p=> {
          _html+=_swatchSettings.item.replace('{{id}}',p.id).replace('{{url}}',p.handle).replace('{{color}}',p.swatchColor).replaceAll('{{name}}',p.swatchName).replace('{{current}}','').replace('{{colcurrent}}','');  
        });
        el.empty().append(_html);
        $('[data-group]').find('[href="'+document.location.pathname+'"] .swatches__swatch').addClass('swatches__swatch--current');
    });
  });
    }
  let sEl=$('[data-group-col]');    
  if (ismissed!==true) {
    sEl=$('[data-group-col]:not(:has(.swatches__col))');
  }      
  if (sEl.length>0) {
     let tags=[];
    sEl.each(function() {
      const t='Product Group Code|'+$(this).data('group-col');
      if (!tags.includes(t)) tags.push(t);    
    });
    renderSwatchAndOverlay(tags,function() {
      sEl.each(function() {
        let overlayHtml='';
        let htmlItems=[];
        let _tag=$(this).data('group-col');
        let _productsForTag=_productsForTags.filter(p=>p.tag==_tag);        
        let _id=$(this).data('group-col-id');
        if (_productsForTag.length==0) {                  
          _productsForTags.push({
              tag:_tag,
              products:_productsData.filter(p=>p.GroupCode==_tag)
          });
          _productsForTag=_productsForTags.filter(p=>p.tag==_tag);
        }
        if (_productsForTag.length>0){   
          _productsForTag[0].products.sort((a, b) => {
              if (a.id == _id) return -1;  // current item goes first
              if (b.id == _id) return 1;   // current item goes first
              return 0;  // maintain original order for other items
          }).forEach(p=>{
            let current='';
            let colcurrent='';
            if (_id==p.id){
              current="swatches__swatch--current";
              colcurrent="swatches__col--current"; 
              overlayHtml=p.overlay;
            }
            htmlItems.push(_swatchSettings.item.replace('{{id}}',p.id).replace('{{url}}',p.handle).replace('{{color}}',p.swatchColor).replaceAll('{{name}}',p.swatchName).replace('{{current}}',current).replace('{{colcurrent}}',colcurrent));
          });
          let _html=$(_swatchSettings.template.replace('{{items}}',htmlItems.join('')));
          if (htmlItems.length>4) {
            _html.append('<a class="product-card__swatch-more" href="'+$(this).closest('.product-card').find('.product-card__image-link').attr('href')+'">+</a>');
          }
          _html.attr('data-group-col',_tag);
          _html.attr('data-group-col-id',_id);
          $(this).replaceWith(_html);
         }
      });
      window.swatches=[];
      initSwatches();
    });
  }
}
function register() {
  jQuery('html').removeClass('no-js').addClass('js');
  if (window.ReadyScript) {
    window.ReadyScript.forEach(x=> {
      loadScript(x.s,x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x=> {
      if (x.p!=undefined) {
        window[x.f].apply(x.p);      
      }
      else {
        window[x.f].apply();      
      }
    });    
  }
  
  if (window.afterLoadWithEvents) {
    $(window).on('scroll.afterLoad',_checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x=> {
      if (x.evt) {
        $(x.el).on(x.evt+'.'+x.f,_checkafterLoadEvents)
      }
    });
  }
}
  
// window.afterLoadWithEvents = window.afterLoadWithEvents || [];
//   window.afterLoadWithEvents.push(
//   {
//       f:"_register",
//       evt: 'mousemove',
//       el: document
//   });
// function _register() {
//   checkUserLocation();
// };
$(document).ready(function(){
  register(); 
  if ($('[data-cart-qty]').length>0) {
    $('[data-cart-qty]').on('focusout',function() {
      if (parseInt($(this).data('cart-qty'))!=parseInt($(this).val())) {
        $(this).closest('form').get(0).submit();
      }
    });
  }
});

// load scripts after page load
function loadScript(sc,callback) {
  if ($.isArray(sc)) {    
      let lc = document.createElement('script'); lc.type = 'text/javascript'; 
      lc.src = sc[0];
      sc.splice(0,1);   
      if (sc.length>0) {
        $(lc).on('load',function() {loadScript(sc,callback)});           ;
      }
      else if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
      }
      document.getElementsByTagName('body')[0].appendChild(lc);
  }
  else {
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc;
    if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
    }
  document.getElementsByTagName('body')[0].appendChild(lc);
  }
}

// For Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});
  
  
var _productsData=[];
var _productsForTags=[];
var _swatchSettings={
  template:'<div class="swatches product-card__swatches">{{items}}</div>',
  item:`<a class="swatches__col" data-product-id="{{id}}" href="/products/{{url}}" title="{{name}}">
<div class="swatches__swatch {{current}}">
  <span style="background-color: {{color}}"></span>
</div>
<div class="swatches__tag">{{name}}</div>
</a>`,   
  overlay:'<div class="product-card__overlays"><div class="product-card__overlay product-card__overlay--{{overlay}}">{{message}}</div></div>'
};
function renderSwatchAndOverlay(tags,callback) {
  if (tags.length>0) {      
  var tagsVar="tag:'"+tags.join("' OR '")+"'";
    FetchDataWithVariables(`query($tagsVar: String){
      products( first: 250,query:$tagsVar) {
        edges{
          node {
            id
            handle
            title
            onlineStoreUrl
            tags
            images(first:2) {    
              edges {       
                node {
                  originalSrc     
                  id
                }
              }
            }
            metafields (identifiers: [ 
             {namespace: "accentuate", key: "overlay"},
             {namespace: "accentuate", key: "top_left_overlay"},
             {namespace: "accentuate", key: "top_right_overlay"},
             {namespace: "accentuate", key: "bottom_overlay"}
            ]){           
              value
              key
              namespace
            }
            variants(first: 100) {
            edges {
              node {       
                price { amount }
                compareAtPrice { amount }
                availableForSale
                id                    
              }
            }
          }
        }
      }  
    }       
  }`,{tagsVar},function(data) {
      //console.log(data);
        
      let Products = data.data.products.edges;
      for(let p of Products) {
               if ((endpoint.includes('pixus') || p.node.onlineStoreUrl != null) && _productsData.filter(c=>c.id==p.node.id.replace('gid://shopify/Product/','')).length==0) {
        let _product={
              id:p.node.id.replace('gid://shopify/Product/',''),
              handle:p.node.handle,
                  title:p.node.title
          };
              _product.overlays=[]; 

        for(let mf of p.node.metafields) {                   
            if (mf!=null && mf.key.indexOf('_overlay')!=-1) 
                    _product.overlays.push({key:mf.key,value:mf.value});
                  if (mf!=null && mf.key=='overlay') _product.overlays.push({key:mf.key,value:mf.value});
        }
              p.node.tags.forEach(t=>{
                if (t.startsWith("Product Group Code|")) _product.GroupCode=t.replace('Product Group Code|','');
                if (t.startsWith("Swatch Name|")) _product.swatchName=t.replace('Swatch Name|','');
                if (t.startsWith("Swatch Colour|")) _product.swatchColor=t.replace('Swatch Colour|','');                 
              });
      
              
              
              _product.images_info=[];
              for(let v of p.node.images.edges) {   
                _product.images_info.push({
                  id:v.node.id,
                  src:v.node.originalSrc,
                  width:1000,
                  height:1500
                });               
         }
         _product.variants=[];    
              let allowSale=false;
        for(let v of p.node.variants.edges) {   
                if (v.node.availableForSale===true) allowSale=true;
                _product.variants.push({
                  id:v.node.id,
                  price:parseFloat(v.node.price.amount)*Shopify.currency.rate,
                  available:v.node.availableForSale,
                  compare_at_price:v.node.compareAtPrice!=null?parseFloat(v.node.compareAtPrice.amount)*Shopify.currency.rate:null
                });               
        }
              let minPriceVariant=_product.variants.sort((a, b) => a.price - b.price)[0];
        _product.compare_at_price_min=parseFloat(minPriceVariant.compare_at_price);
              _product.price_min=parseFloat(minPriceVariant.price);
               let _overlayHtml=_swatchSettings.overlay;
               let overlayItems=[];
               _product.overlays.forEach(o=> {
                      switch (o.key) {
                        case 'top_left_overlay':  
                          _overlayHtml=_overlayHtml.replace('{{overlay}}','top-left');
                          break;
                        case 'top_right_overlay':
                          _overlayHtml=_overlayHtml.replace('{{overlay}}','top-right');
                          break;
                        case 'bottom_overlay':
                          _overlayHtml=_overlayHtml.replace('{{overlay}}','bottom');
                          break;
                        default:
                          _overlayHtml=_overlayHtml.replace('{{overlay}}','');
                          break;
                      }
                      overlayItems.push(_overlayHtml.replace('{{message}}',o.value));
               });
              _product.overlay=overlayItems.join('');
              if (allowSale) {
          _productsData.push(_product);
          }
        }
      }
      //console.log(_productsData);     
      callback.apply();
    });
  }
  else {
    callback.apply();
  }
  } 

document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = "url('" + bg + "')";
    }
});

// Product Page LightGallery Popup
if($("#lightgallery").length != 0) {
  lightGallery(document.getElementById('lightgallery'), {
    selector: '.product-images__featured-item',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Gallery Page LightGallery Popup
if($("#lightgallerypage").length != 0) {
  lightGallery(document.getElementById('lightgallerypage'), {
    selector: '.gallery__image-link',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Swiper Video play and pause
var vids = $("video"); 
$.each(vids, function(){
  this.controls = false; 
}); 
$("video").click(function() {
  if (this.paused) {
    this.play();
  } else {
    this.pause();
  }
});
$("video").bind('stop pause', function(e) {
  console.log("stopped");
  $(this).parent().removeClass('responsive-video--stopped');
});

$("video").bind('play', function(e) {
  console.log("playing");
  $(this).parent().addClass('responsive-video--stopped');
});

// Swiper Slider - Default
if ($('.swiper--default').length > 0) {
  initSwipers();
}
var productImagesSwiper;
function initSwipers() {
  let swiperInstances = [];
  $(".swiper--default").each(function(index, obj){ 
    const $this = $(this);
    if (!$this.hasClass('swiper-initialized')) {
    $this.addClass("swiper-" + index); 
    $this.find(".swiper-pagination").addClass("pagination-" + index);
    $this.find(".swiper-button-prev").addClass("prev-" + index);
    $this.find(".swiper-button-next").addClass("next-" + index); 
    $this.find(".swiper-scrollbar").addClass("scrollbar-" + index);

    if($this.hasClass('swiper--autoplay')) {
      $autoplay = { delay: 4000 };
    } else {
      $autoplay = "";
    }

    if($this.hasClass('swiper--snap')) {
      $freemode = false;
    } else {
      $freemode = true;
    }

    if($this.find(".swiper-pagination").length) {
      $pagination = '.pagination-' + index;
    } else {
      $pagination = null;
    }
    if($this.find(".swiper-pagination--fraction").length) {
      $pagination_type = 'fraction';
    } else {
      $pagination_type = 'bullets';
    }

    if($this.find(".swiper-button-next").length) {
      $next = '.next-' + index;
    } else {
      $next = null;
    }

    if($this.find(".swiper-button-prev").length) {
      $prev = '.prev-' + index;
    } else {
      $prev = null;
    }    

    if($this.find(".swiper-scrollbar").length) {
      $scrollbar = '.scrollbar-' + index;
    } else {
      $scrollbar = null;
    }
    swiperInstances[index] = new Swiper(".swiper-" + index, {
      autoplay: $autoplay,
      slidesPerView: 'auto',
      //centerInsufficientSlides: true,
      navigation: {
        prevEl: $prev,  
        nextEl: $next, 
      },
      pagination: {
        el: $pagination,
        type: $pagination_type,
        clickable: true
      },
      scrollbar: {
        el: $scrollbar,
        draggable: true,
        snapOnRelease: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: $freemode,
        minimumVelocity: 0,
        momentumBounce: false,
        momentumRatio: 0.5,
        momentumVelocityRatio: 1.5,
      }
    });
    }
  });
  setTimeout(function () {
    for (const slider of swiperInstances) {
      if (slider!=undefined) {
        slider.update();
        if(slider.isLocked == true) {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        }
        slider.on('lock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        });
        slider.on('unlock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).removeClass('swiper-nav--locked');
        });
        var id = $(slider.el).attr('id');
      }
    }
  }, 50);
}

// Swiper Slider - Product Page
if ($('.swiper--product-images').length > 0) {
  const productThumbsSwiper = new Swiper(".swiper--product-thumbs", {
    spaceBetween: 20,
    slidesPerView: 'auto',
    direction: 'vertical',
    watchSlidesProgress: true,
  });
  productImagesSwiper = new Swiper(".swiper--product-images", {
    pagination: {
      el: ".swiper-pagination--product-images",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next--product-images",
      prevEl: ".swiper-button-prev--product-images",
    },
    thumbs: {
      swiper: productThumbsSwiper,
    },
  });
}

// Promos Slider
$(document).ready(function(){
  var slides = $('.promos__message');
  var i = 2;
  setInterval(function(){
    if(i < slides.length + 1) {
      $('.promos__message').removeClass('inactive');
      $('.promos__message--' + (i - 1)).removeClass('active').addClass('inactive');
      $('.promos__message--' + i).addClass('active');
      i++;
    } else {
      i=1;
      $('.promos__message').removeClass('inactive');
      // Remove active class from last slide and add inactive class
      $('.promos__message--' + slides.length).removeClass('active').addClass('inactive');
      $('.promos__message--' + i).addClass('active');
      i++;
    }
  }, 3200);
});

function _getWindowLocation() {
  for (var t = window.location.href.replace(/%3C/g, "&lt;").replace(/%3E/g, "&gt;"), e = [], n = 0; n < t.length; n++) e.push(t.charAt(n));
  var i = e.join("").split("&lt;").join("%3C").split("&gt;").join("%3E"),
      r = "",
      o = i.replace(/#.*$/, "");
  return o.split("?").length > 1 && (r = o.split("?")[1]).length > 0 && (r = "?" + r), { pathname: window.location.pathname, href: i, search: r };
}

//show loading overlay
function loader(isShow) {
  if (isShow) {
    $('.loader').show();
  }
  else {
    $('.loader').hide();
  }
}

// General Accordion
$('.faqs-accordion__title').off('click keypress').on('click keypress', function (event) {
  if (event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
    if ($(this).hasClass('active')) {
      $('.faqs-accordion__title').next().slideUp();
      $('.faqs-accordion__title').removeClass('active');
      $('.faqs-accordion__title').attr('aria-expanded', 'false');
    } else {
      $('.faqs-accordion__title').attr('aria-expanded', 'false');
      $('.faqs-accordion__title').removeClass('active');
      $('.faqs-accordion__title').next().slideUp();
      $(this).next().slideDown();
      $(this).addClass('active');
      $(this).attr('aria-expanded', 'true');
    }
  }
});

// Product Accordion
$('.product-accordion__title').off('click keypress').on('click keypress', function (event) {
  if (event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
    if($(this).hasClass('active')) {
      $('.product-accordion__title').next().slideUp();
      $('.product-accordion__title').removeClass('active');
      $('.product-accordion__title').attr('aria-expanded','false');
    } else {
      $('.product-accordion__title').attr('aria-expanded','false');
      $('.product-accordion__title').removeClass('active');
      $('.product-accordion__title').next().slideUp();
      $(this).next().slideDown();
      $(this).addClass('active');
      $(this).attr('aria-expanded','true');
    }
  }
});

// Smooth Scroll
$(".scroll-link").click(function(e) {
  e.preventDefault();
  var targetElement = $(this).attr("href");
  var targetPosition = $(targetElement).offset().top;
  $("html, body").animate({ scrollTop: targetPosition - 0 }, "slow");
});

// Cart Discount
function updateCartDiscount(discountCode) {
  const cartId=getCookie('cart') ? `gid://shopify/Cart/${getCookie('cart')}` : '';
  if (cartId != '' )  {
    const _var={
      cartId:cartId,
      discountCodes:discountCode
    };
    FetchDataWithVariables(`
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            discountCodes {
              code
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      `,_var,function(data) {
        _updateCartContent(discountCode!=''?true:false);
      }
    );
  }
}

document.querySelectorAll('[data-action="discountcode"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount(document.querySelector('[data-discountcode]').value);
  });
});

document.querySelectorAll('[data-action="discountremove"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount('');
    $('#discount').val('');
  });
});

// Product Card - Add to Basket
window.afterLoadWithEvents=window.afterLoadWithEvents || [];
  window.afterLoadWithEvents.push(
  {
    f:'FeaturedAddToBasket',
    evt: 'mousemove',
    el: document
  }
);
window._variantSelected = window._variantSelected || null
function FeaturedAddToBasket() {
  $('[data-add-to-cart-featured]').off('click').on('click',function() {
    _variantSelected=$(this).closest('[data-form]').find('[data-qtyadd]').attr('data-qtyadd'); 
    addItemToCartProductCard(_variantSelected,1);
  });
  $('[data-qtyadd]').each(function() {
    let plusMinusButton=$(this);
    if (parseInt($('[data-inbasket="'+plusMinusButton.attr('data-qtyadd')+'"]').text())>0) {
      plusMinusButton.show();                             
      plusMinusButton.closest('[data-form]').find('[data-add-to-cart-featured]').hide();
      plusMinusButton.closest('[data-form]').find('.product-card__button--more').addClass('product-card__button--added');
    }
    $('[data-minus-basket]',plusMinusButton).off('click').on('click',function() {
      let newQty=parseInt($('[data-inbasket="'+plusMinusButton.attr('data-qtyadd')+'"]').eq(0).text())-parseInt($(this).parent().find('input').val());
      UpdateItemInCart(plusMinusButton.attr('data-qtyadd'),newQty);
      if (newQty==0) {
        plusMinusButton.closest('[data-form]').find('[data-add-to-cart-featured]').show();
        plusMinusButton.closest('[data-form]').find('.product-card__button--more').removeClass('product-card__button--added');
        plusMinusButton.hide();                  
      }
    });
    $('[data-plus-basket]',plusMinusButton).off('click').on('click',function() {
      let newQty=parseInt($('[data-inbasket="'+plusMinusButton.attr('data-qtyadd')+'"]').eq(0).text())+parseInt($(this).parent().find('input').val());
      UpdateItemInCart(plusMinusButton.attr('data-qtyadd'),newQty);
    });

    $('[data-el="option"]').off('change').on('change',function() {
      const pEl=$(this).closest('.product-card__details');
      pEl.find('[data-card-price]').text($(this).find('option:selected').data('optprice'));
      pEl.find('[data-card-compare]').text($(this).find('option:selected').data('optcompare'));
      if($(this).find('option:selected').data('optcompare') != "") {
        pEl.find('.product-card__price').removeClass('product-card__price--on-sale').addClass('product-card__price--on-sale');
      } else {
        pEl.find('.product-card__price').removeClass('product-card__price--on-sale');
      }
      pEl.find('[data-qtyadd]').attr('data-qtyadd',$(this).val());
      pEl.find('[data-inbasket]').attr('data-inbasket',$(this).val());        
      if ($(this).find('option:selected').data('optavailable')==true) {
        pEl.find('[data-add-to-cart-featured]').val('Add to Bag');
        pEl.find('[data-add-to-cart-featured]').removeClass('disabled');
      }
      else {
        pEl.find('[data-add-to-cart-featured]').val('Sold Out');
        pEl.find('[data-add-to-cart-featured]').addClass('disabled');
      }
      updateMiniCartContents();
    });
  });
}

// Featured Collection - Tabs
$('.featured-collection__tab').off('click').on('click', function () {
  var tab = $(this).data('tab');
  $('.featured-collection__tab').removeClass('featured-collection__tab--active');
  $('.featured-collection__tab-content').hide();
  $(this).addClass('featured-collection__tab--active');
  $('#' + tab).show();
});

// Delayed Video (On mousemove)
var videoPlayer = document.getElementById('vbanner');
if(videoPlayer){
  window.afterLoadWithEvents.push(
  {
     f:'_loadVideo',
     evt:'mousemove',
     el: document
   }
  ); 
  function _loadVideo() {
    // Video
    var valSources = document.querySelectorAll('video#vbanner source'),
    valVideo = document.querySelector('video#vbanner'),
    valDataSrc = 'data-src',
    valDataPoster = 'data-poster';

    if(window.innerWidth < 601 ) {
      valDataSrc = 'data-src-mobile';
      valDataPoster = 'data-poster-mobile';
    }

    for(var i = 0; i<valSources.length;i++) {
      valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
    }

    valVideo.load();

    videoPlayer.addEventListener("canplaythrough", function() {
      videoPlayer.play();
    });
  }
}

// AutoPlay Video
var videoAuto = document.getElementById('vbannerauto');
if(videoAuto){
  // Video
  var valSources = document.querySelectorAll('video#vbannerauto source'),
  valVideo = document.querySelector('video#vbannerauto'),
  valDataSrc = 'data-src',
  valDataPoster = 'data-poster';

  if(window.innerWidth < 601 ) {
    valDataSrc = 'data-src-mobile';
    valDataPoster = 'data-poster-mobile';
  }

  for(var i = 0; i<valSources.length;i++) {
    valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
  }

  valVideo.load();

  videoAuto.addEventListener("canplaythrough", function() {
    videoAuto.play();
  });
}

// Animations Start
(function($) {
  $.fn.visible = function(partial) {    
    var $t            = $(this),
        $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top + 50,
        _bottom       = _top + $t.height(),
        compareTop    = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };
})(jQuery);

$(document).ready(function() {
  $(".js-animation").each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("animate");
    }
  });
});  

$(window).scroll(function(event) {
  $(".js-animation").each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("animate"); 
    }
  });
});

// Product Page - Qty Buttons
$(document).ready(function () {
  $('.product-add__quantity-add').on('click', function () {
    const $input = $(this).siblings('[data-quantity-input]');
    const currentVal = parseInt($input.val()) || 1;
    $input.val(currentVal + 1).change();
  });

  $('.product-add__quantity-minus').on('click', function () {
    const $input = $(this).siblings('[data-quantity-input]');
    const currentVal = parseInt($input.val()) || 1;
    if (currentVal > 1) {
      $input.val(currentVal - 1).change();
    }
  });
});

// // Product Page - Subscriptions
// $(document).ready(function () {
//   $('.shopify_subscriptions_fieldset input[type="radio"]:checked').parent().addClass('checked');
//   $('.shopify_subscriptions_fieldset input[type="radio"]').on('change', function () {
//     const name = $(this).attr('name');
//     $('input[type="radio"][name="' + name + '"]').parent().removeClass('checked');
//     $(this).parent().addClass('checked');
//   });

//   $('.shopify_subscriptions_app_block_label_children input').each(function () {
//     var $input = $(this);
//     var price = $input.data('variant-price');

//     // Only proceed if the data-variant-price exists
//     if (price !== undefined) {
//       var $priceSpan = $('<span class="custom-variant-price">' + price + '</span>');
//       $input.parent().append($priceSpan);
//     }
//   });
// });

// Popup - General
$(document).ready(function () {
  // Popup - Open
  $('[data-popup]').on('click', function () {
    var popup = $(this).attr("data-popup");
    $('#popup-' + popup).addClass('popup--active');
    $('html').addClass('noscroll-popup');
  });

  // Popup - Close
  $('.popup__close, .popup__save').on('click', function () {
    $('.popup').removeClass('popup--active');
    $('html').removeClass('noscroll-popup');
  });

  // Popup - Close Outside Panel
  $('.popup__panel').click(function(event) {
    event.stopPropagation(); // Prevent the click event from reaching .popup
  });
  $('.popup').click(function() {
    $('.popup').removeClass('popup--active');
    $('html').removeClass('noscroll-popup');
  });
});

// Product Page - Read More
$(document).ready(function () {
  $('.product-short-description__more').on('click', function () {
    $('.product-short-description__full').slideToggle();
    $('.product-short-description__more span').toggle();
  });
});